import React, {useState, useEffect} from 'react'
import ContactApi from '../api/ContactApi';
import ContactDropdown from '../component/dropdown/ContactDropdown';

const ContactForm = ({contactId, onSubmits, toogle}) => {
    const nonce = devsAccountingApi.nonce;
    const [message, setMessage] = useState("");
    const [fetchData, setFetchingData] = useState(false);
    const [errors, setErrors] = useState({});
    const [state, setState] = useState({
        name: "",
        type: "",
        nonce: nonce,
        email: "",
        address: "",
        phone: "",
    });
    const [loading, setLoading] = useState(false); // Loading state added

    useEffect(() => {
        if(contactId){
            getContact(contactId);
        }
    }, [contactId]);

    const contactOptions =[
        { value: 'customer', label: 'Customer' },
        { value: 'vendor', label: 'Vendor' },
    ]

    const handleChange = (e) => {
        const { name, value } = e.target;
            setState({
                ...state,
                [name]: value,
            });
    };

    const getContact = async (contactId) => {
        setFetchingData(true);
        const res = await ContactApi.show(contactId);
        if(res){
            setFetchingData(false);
            setState(res);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors('');
        const res = await ContactApi.save(state);
        if (res.errors) {
            setErrors(res.errors);
            setLoading(false);
        } else {
            setMessage(res.message);
            setLoading(false);
            onSubmits();
            toogle();
        }
    };

  return (
    <div>
        {message &&
            <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                <p className="font-bold">{message}</p>
            </div>
        }
        {!fetchData ?
            <section className="p-6 mx-auto rounded-md">
                <form onSubmit={handleSubmit}>
                    <div className='grid grid-cols-2'>
                        <div>
                            <h2 className="text-lg font-semibold text-gray-700 capitalize dark:text-white">{contactId ? 'Edit' : 'Add'} Contacts</h2>
                        </div>
                        <div className="flex justify-end">
                            <button type='submit' className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600">
                                {loading ? 'Submitting...' : 'Submit'} {/* Display 'Submitting...' when loading, 'Submit' otherwise */}
                            </button>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-6 mt-4">
                        <div>
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="name">Name</label>
                            <input id="name" type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="name"
                                value={state.name} onChange={handleChange} />
                            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                        </div>
                        <div className="">
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="type">Type</label>
                            <ContactDropdown options={contactOptions} onSelectChange={handleChange} name="type" selectedValue={state.type} />
                            {errors.type && <p className="text-red-500 text-xs mt-1">{errors.type}</p>}
                        </div>
                        <div>
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="email">Email</label>
                            <input id="email" type="email" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="email"
                                value={state.email} onChange={handleChange} />
                            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                        </div>
                        <div>
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="address">Address</label>
                            <textarea id="address" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="address"
                                value={state.address} onChange={handleChange} />
                            {errors.address && <p className="text-red-500 text-xs mt-1">{errors.address}</p>}
                        </div>
                        <div>
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="phone">Phone</label>
                            <input id="phone" type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="phone"
                                value={state.phone} onChange={handleChange} />
                            {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                        </div>
                    </div>
                </form>
            </section>
            : <div className='m-auto'><p className='text-2xl text-bold text-center'>Loading...</p> </div>}
    </div>
  )
}

export default ContactForm;